import { render } from "./en.vue?vue&type=template&id=4a496fca&scoped=true&ts=true"
import script from "./en.vue?vue&type=script&lang=ts"
export * from "./en.vue?vue&type=script&lang=ts"

import "./en.vue?vue&type=style&index=0&id=4a496fca&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a496fca"]])

export default __exports__